module.exports = __webpack_public_path__ + "img/right.6f291396.png";